/**
 * @param filterSection is the section of the filter that contains the relevant fixed and selected filter values.
 * @param values is the values to be filtered.
 *
 * @returns true if the values are viable after being filtered. i.e. if contains values in both the fixed and selected filters.
 */
export const hasValidValuesForFilter = (filterSection, values) => {
    const selectedValues = filterSection.options.filter(o => o.selected).map(o => o.value);
    return isValuesInFilter(values, filterSection.fixed) && isValuesInFilter(values, selectedValues);
};
/**
 * @param values is the values to be filtered.
 * @param selectedFilterValues is the selected filter value options (e.g. ['IMAX', '3D']).
 *
 * @returns true if the values are viable after being filtered. i.e. if one of the values is in the filter.
 */
const isValuesInFilter = (values, selectedFilterValues) => {
    // if no selected filter values, consider object to have 'passed' that filter
    if (!selectedFilterValues.length)
        return true;
    return values.some(i => selectedFilterValues.includes(i));
};
//# sourceMappingURL=has-valid-values-for-filter.js.map